import type { Theme } from '../../types/theme';

export const appleTheme: Theme = {
  id: 'apple',
  name: 'Apple',
  description: 'Premium white space with photography-first design. SF Pro Display and minimal chrome.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/apple/DESIGN.md',
  visualKeywords: ['white space', 'photography', 'SF Pro', 'premium', 'blue pill', 'minimal chrome'],
  colors: {
    background: '#ffffff',
    surface: '#f5f5f7',
    surfaceElevated: '#ffffff',
    surfaceDark: '#1d1d1f',
    textPrimary: '#1d1d1f',
    textSecondary: '#333333',
    textMuted: '#7a7a7a',
    border: '#e0e0e0',
    borderSubtle: '#f0f0f0',
    primary: '#0066cc',
    primaryHover: '#0071e3',
    primaryActive: '#004499',
    accent: '#0066cc',
    onPrimary: '#ffffff',
    success: '#34c759',
    warning: '#ff9500',
    error: '#ff3b30',
  },
  typography: {
    headingFont: '"SF Pro Display", -apple-system, system-ui, sans-serif',
    bodyFont: '"SF Pro Text", -apple-system, system-ui, sans-serif',
    monoFont: '"SF Mono", Menlo, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.28px',
    letterSpacingBody: '-0.374px',
  },
  radius: {
    button: '9999px',
    card: '0px',
    panel: '0px',
    badge: '9999px',
    input: '9999px',
  },
  shadow: {
    card: 'none',
    elevated: '0 3px 5px 30px rgba(0, 0, 0, 0.22)',
    button: 'none',
    none: 'none',
  },
  layout: {
    maxWidth: '980px',
    sectionSpacing: '80px',
    cardPadding: '48px',
    navHeight: '44px',
  },
  mood: {
    density: 'low',
    tone: 'premium, cinematic, product-focused',
    productFit: ['Consumer electronics', 'Software products', 'Premium services', 'Creative tools'],
    bestFor: ['Product showcases', 'Premium brands', 'Consumer software', 'Creative industries'],
    notGoodFor: ['Developer tools', 'Data-heavy dashboards', 'Enterprise products', 'Social platforms'],
  },
};
